import { Styles, generateClasses } from 'netline-ui';

export const supportContentClasses = generateClasses('SupportContent', ['root', 'titleText', 'contactValue'] as const);

const styles: Styles = ({ theme: { palette } }) => ({
  [`&.${supportContentClasses.root}`]: {
    position: 'relative',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  [`.${supportContentClasses.titleText}`]: {
    flex: 1,
  },
  [`.${supportContentClasses.contactValue}`]: {
    color: palette.primary.main,
  },
});

export default styles;
